import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Layout, Title } from 'common/components/layout';
import SubMenu from 'profile/common/SubMenu';
import { getCustomer } from 'redux/customer/actions';

import ViewCustomer from './ViewCustomer';

class Account extends Component {
  componentDidMount() {
    const { props } = this;
    props.getCustomer();
  }

  render() {
    const { settings, customer } = this.props;
    if (!settings.data || !customer.data) {
      return (
        <Layout title="Your Information" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }
    return (
      <Layout title="Your Information">
        <Title>Your Account</Title>
        <SubMenu />

        <div className="c7-account__information">
          <h2>Your Information</h2>

          <div className="c7-account__information__address">
            <ViewCustomer customer={customer.data} />

            <p>
              <Link to="/profile/account/edit" className="c7-button-alt-small">
                Edit
              </Link>
            </p>
          </div>

          <div className="c7-account__information__password">
            <p>Password: ********</p>

            <p>
              <Link
                to="/profile/account/password"
                className="c7-button-alt-small"
              >
                Edit
              </Link>
            </p>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting,
  customer: state.customer
});

export default connect(mapStateToProps, {
  getCustomer
})(Account);
